import { render, staticRenderFns } from "./milling-quantity.card.vue?vue&type=template&id=08178a84&"
import script from "./milling-quantity.card.vue?vue&type=script&lang=js&"
export * from "./milling-quantity.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports